import axios from 'axios';


let baseURL = window.location.host === 'localhost:3000' ? 'http://localhost:5000' : process.env.REACT_APP_API_BASE_URL;  //variable set in hosting provider to hide my api url

const API = axios.create({ baseURL: baseURL});

//set token before executing request
API.interceptors.request.use((req)=>{

    if(localStorage.getItem('profile')){

        const token = JSON.parse(localStorage.getItem('profile')).token;

        req.headers.Authorization = `Bearer ${token}`;
    }

    return req; 
});

export const searchPosts = (searchQuery) => API.get(`/posts/search?searchQuery=${searchQuery.search || 'none'}&tags=${searchQuery.tags}`); 
export const fetchPosts = (page) => API.get(`/posts?page=${page}`);
export const fetchPost = (id) => API.get(`/posts/${id}`);

//TODO - Fetching Posts for user id 

//TODO - fetching Posts for users/groups which user id follows

//TODO - fetching Posts based on trending

//TODO - Fetching Posts based on tags etc. -- All this could be done via the search request however -- would it be as performant?

//Posts CRUD
export const createPost = (userId, data) => API.post(`/posts/${userId}`, data);
export const createMediaPost = (userId, data) => API.post(`/posts/media/${userId}`, data);
export const updatePost = (id, data) => API.patch(`/posts/${id}`, data);
export const deletePost = (id) => API.delete(`/posts/${id}`);
export const likePost = (id) => API.patch(`/posts/${id}/likePost`);

//post comments CRUD
export const comment = (value, id, userId) => API.post(`/posts/${id}/commentPost`, {value, userId});
export const getComments = (id, page) => API.get(`/posts/${id}/comments?page=${page}`);


//routes for the auth
export const login = (formData) => API.post('/users/login', formData);
export const signup = (formData) => API.post('/users/signup', formData);
export const deleteAccount = (id) => API.delete(`/users/delete/${id}`);

//routes for user data -- //TODO
export const fetchProfile = (id, invokingId) => API.get(`/profile/${id}?invokingId=${invokingId}`);
export const fetchUserPosts = (id, page) => API.get(`/profile/posts/${id}?page=${page}`);
export const editProfile = (formData) => API.patch('/users/edit', formData);
export const editProfileImage = (formData) => API.patch('/users/edit/profileImage', formData);
export const editProfileBGImage = (formData) => API.patch('/users/edit/profileBackground', formData);
export const editProfileInfo = (formData) => API.patch('/users/edit/info', formData);

export const fetchFollowers = (id, page) => API.get(`/users/followers?id=${id}&page=${page}`);
export const fetchFollowing = (id, page) => API.get(`/users/following?id=${id}&page=${page}`);

export const followUser = (id, followId) => API.patch(`/users/follow?id=${id}&followId=${followId}`); 
export const unFollowUser = (id, followId) => API.patch(`/users/unfollow?id=${id}&followId=${followId}`);

export const fetchSuggestedUsers = (id=null, page) => API.get(`/users/suggested?id=${id}&page=${page}`);

export const searchUsers = (searchQuery) => API.get(`/users/search?searchQuery=${searchQuery.search || 'none'}`); 

//Notifications
export const fetchHistoricNotifications = (id, page, data) => API.get(`/notifications/${id}?page=${page}`, {
    params: {
      data
    }
  });
export const markNotificationsAsRead = (id, notifications) => API.patch(`/notifications/${id}`, notifications);


//chat
export const fetchChats = (id, page=1) => API.get(`/chat/${id}?page=${page}`);
export const startChat = (id, chatData) => API.post(`/chat/room/${id}`, chatData);
export const fetchHistoricMessages = (id, chatRoomId, page) => API.get(`/chat/messages/${id}?chatRoomId=${chatRoomId}&page=${page}`);